import { create } from 'zustand';

const EditJobStore = create((set) => ({
  EditJobResponse: '',
  setEditJobResponse: (response) => {
    set(() => ({
      EditJobResponse: response,
    }));
  },
}));

export default EditJobStore;
